exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-range-type-drop-down .bi-common-button{color:#000!important;border-color:#c0bfc0!important;background-color:#fff!important}", ""]);

// exports
